import {EventEmitter} from 'events';
import assign from 'object-assign';

const Dispatcher = assign({}, EventEmitter.prototype, {

  FRACTION_STORE_CHANGE : "Fraction.Store.Change",
  LOCALE_CHANGE : "Locale.Change",


  USER_CHANGE             : "User.Change",
  RECAPTCHA_RENDERED      : "Recaptcha.Rendered",
  LICENSE_UPDATED         : "License.Updated",
  LICENSE_UPDATING        : "License.Updating",
  LIBRARY_UPDATED         : "Library.Updated",

  UPDATE_ACCESS_CODES     : "AccessCodes.Update",

  UPDATE_FRACTION_STORE   : "Update.Fraction.Store",

  LIBRARY_HIDE_SLIDEOUT   : "Library.Hide.Slideout",

  BOOKMARKS_CHANGE        : "Bookmarks.Change",
  BOOKMARKS_ADD           : "Bookmarks.Add",
  BOOKMARKS_DELETE        : "Bookmarks.Delete",
  BOOKMARKS_ACTION_FAILED : "Bookmarks.Action.Failed",

  BOOK_OPENED             : "Book.Opened",
  BOOK_CHANGE             : "Book.Change",
  BOOK_TOC_LOADED         : "Book.TOC.Loaded",
  BOOK_SPINE_LOADED       : "Book.Spine.Loaded",
  BOOK_FIGURES_LOADED     : "Book.Figures.Loaded",
  BOOK_PAGEBREAKS_LOADED  : "Book.PageBreaks.Loaded",

  HIGHLIGHTS_CHANGE       : "Highlights.Change",
  HIGHLIGHTS_DELETE       : "Highlights.Delete",
  HIGHLIGHT_SELECTION     : "Highlight.Selection",
  HIGHLIGHT_EMOJI_SELECTION: "Highlight.Emoji.Selection",
  HIGHLIGHT_UPDATE        : "Highlight.Update",
  HIGHLIGHT_ADDED         : "Highlight.Added",
  HIGHLIGHT_UPDATED       : "Highlight.Updated",
  RESET_HIGHLIGHTS        : "Highlight.Reset",

  SET_ENHANCED_FORMATTING : "Set.Enhanced.Formatting",
  SET_FAST_HIGHLIGHTER    : "Set.Fast.Highlighter",

  MARKERS_CHANGE          : "Markers.Change",
  MARKERS_DELETE          : "Markers.Delete",
  MARKERS_SET_CURRENT     : "Markers.Set.Current",

  MODAL_OPEN              : "Modal.Open",
  MODAL_CLOSE             : "Modal.Close",

  POPOVER_OPEN            : "Popover.Open",
  POPOVER_CLOSE           : "Popover.Close",

  OPEN_MODAL          : "Open.Modal",
  CLOSE_MODAL         : "Close.Modal",
  MODAL_OPENED        : "Modal.Opened",
  MODAL_CLOSED        : "Modal.Closed",
  MODAL_STORE_CHANGE  : "Modal.Store.Change",

  SCRUBBER_OPEN       : "Scrubber.Open",
  SCRUBBER_CLOSE      : "Scrubber.Close",

  MAIN_MENU_OPEN          : "Main.Menu.Open",
  MAIN_MENU_CLOSE         : "Main.Menu.Close",

  CLOSE_MENU              : "Close.Menu",

  NOTES_DOWN              : "Notes.Down",
  NOTES_UP                : "Notes.Up",

  NAVIGATOR_POP           : "Navigator.pop",
  NAVIGATOR_PUSH          : "Navigator.push",
  NAVIGATOR_REPLACE       : "Navigator.replace",
  NAVIGATOR_RESET         : "Navigator.reset",
  NAVIGATOR_REPLACE_LAST  : "Navigator.replaceLast",
  NAVIGATOR_STATE_CHANGE  : "Navigator.state.change",

  SAVE_USER_DATA          : "Save.User.Data",

  TTS_OPEN: "Tts.open",
  TTS_CLOSE: "Tts.close",

  // Jigsaw Events (hence the colons)
  // All are fired with their arguments following the isbn of the book
  BOOK_PAGE_READY                   : "page:ready",
  BOOK_PAGE_LOAD                    : "page:load",
  BOOK_PAGE_SCROLL                  : "page:scroll",
  BOOK_PAGE_SCROLL_FULLSPEED        : "page:scroll:fullspeed",
  BOOK_SELECTION_MADE               : "book:selectionMade",
  BOOK_SELECTION_CANCELLED          : "book:selectionCancelled",
  BOOK_SELECTION_WITH_POSITION      : "book:selectionWithPosition",
  BOOK_CLICK                        : "book:click",
  BOOK_TOUCH_END                    : "book:touchend",
  BOOK_TOUCH_START                  : "book:touchstart",
  BOOK_TOUCH_MOVE                   : "book:touchmove",
  BOOK_MOUSE_WHEEL                  : "book:mousewheel",
  BOOK_MOUSE_MOVE                   : "book:mousemove",
  BOOK_KEY_PRESS                    : "book:keypress",
  BOOK_KEY_DOWN                     : "book:keydown",
  BOOK_KEY_UP                       : "book:keyup",
  BOOK_PAGEBREAK                    : "book:pagebreak",
  BOOK_NAVIGATION_REQUESTED         : "book:navigationRequested",
  BOOK_NO_COPY                      : "book:no-copy",
  BOOK_SNIPPET_READY                : "snippet:ready",
  BOOK_SNIPPET_EXIT                 : "snippet:exit",
  BOOK_HIGHLIGHT_CLICK              : "highlight:click",
  BOOK_HIGHLIGHT_MOUSE_OVER         : "highlight:mouseover",
  BOOK_HIGHLIGHT_MOUSE_OUT          : "highlight:mouseout",
  BOOK_IMAGE_BUTTON_CLICK           : "imagebutton:click",
  BOOK_NOTEICON_CLICK               : "noteicon:click",
  HIGHLIGHTS_RENDER                 : "highlights:render",
  USER_SIGNOUT                      : "user:signout",
  TTS_STATUS                        : "tts:status",

  BOOK_NEXT_PAGE                    : "book:nextpage",
  BOOK_PREVIOUS_PAGE                : "book:previouspage",

  BOOK_PLACEHOLDER_RESIZE           : "Book.Placeholder.Resize",

  TOGGLE_PANEL                      : "toggle.panel",
  SHOW_PANEL                        : "show.panel",
  SHOW_UNSEEN_PANEL                 : "show.unseen.panel",
  HIDE_PANEL                        : "hide.panel",
  HIDE_ALL_PANELS                   : "hide.all.panels",
  LOAD_SAVED_PANELS                 : "load.saved.panels",
  PANEL_CHANGE                      : "change.panel",

  TOGGLE_OVERLAY                    : "toggle.overlay",
  SHOW_OVERLAY                      : "show.overlay",
  HIDE_OVERLAY                      : "hide.overlay",

  NEW_TOUR                          : "New.Tour",
  END_TOUR                          : "End.Tour",
  CHANGE_CHROME                     : "Change.Chrome",

  GET_FOLLOWERS_AND_BLOCKS         : "Get.Followers.Blocks",
  RECEIVE_FOLLOWERS_AND_BLOCKS     : "Receive.Followers.Blocked",
  GET_FOLLOWERS_AND_BLOCKS_ERROR   : "Get.Followers.Blocks.Error",
  FOLLOWER_BLOCKED                 : "Follower.Blocked",
  USER_UNBLOCKED                   : "User.UnBlocked",
  FOLLOWER_STORE_CHANGE            : "Follower.Store.Change",

  FLASHCARD_CREATE_REQUEST          : "Flashcard.New",
  FLASHCARD_CLOSE_VIEWER            : "Flashcard.Close",

  OVERLEAF_SET_PROFICIENCY          : "Overleaf.Proficiency.Set",

  VIEW_UPDATED_BOOKS_SHOW           : "View.Updated.Books.Show",
  
  PRINT_START                       : "print.start",
  PRINT_DONE                        : "print.done",
  PRINT_FAILED                      : "print.failed",


  getJigsawEvents(){
    return [
      this.BOOK_PAGE_READY, this.BOOK_PAGE_LOAD, this.BOOK_PAGE_SCROLL,
      this.BOOK_PAGE_SCROLL_FULLSPEED, this.BOOK_SELECTION_MADE,
      this.BOOK_SELECTION_CANCELLED, this.BOOK_SELECTION_WITH_POSITION,
      this.BOOK_CLICK, this.BOOK_TOUCH_END,  this.BOOK_TOUCH_MOVE,
      this.BOOK_TOUCH_START, this.BOOK_MOUSE_WHEEL, this.BOOK_MOUSE_MOVE,
      this.BOOK_KEY_PRESS, this.BOOK_KEY_DOWN, this.BOOK_KEY_UP,
      this.BOOK_PAGEBREAK, this.BOOK_NAVIGATION_REQUESTED, this.BOOK_NO_COPY,
      this.BOOK_SNIPPET_READY, this.BOOK_SNIPPET_EXIT,
      this.BOOK_HIGHLIGHT_CLICK, this.BOOK_HIGHLIGHT_MOUSE_OVER,
      this.BOOK_HIGHLIGHT_MOUSE_OUT, this.BOOK_NOTEICON_CLICK, this.USER_SIGNOUT,
      this.TTS_STATUS, this.HIGHLIGHTS_RENDER, this.BOOK_IMAGE_BUTTON_CLICK
    ];
  },

  getMaxListeners(){
    return this._maxListeners || 11;
  },

  listenerCounts: 0,
  namespaces: {},

  bind(event, fun, namespace){
    this.setMaxListeners(this.getMaxListeners() + 1);
    this.listenerCounts++;
    this.on(event, fun);
    this.nameSpaceEvent(fun, namespace);
    // console.log("Binding New Event", event);
    // console.log(`${this.listenerCounts}/${this.getMaxListeners()} Max Listeners`);
  },

  bindOnce(event, fun, namespace){
    this.once(event, fun);
    this.nameSpaceEvent(fun, namespace);
    // console.log("Binding Once to Event", event);
  },

  nameSpaceEvent(fun, namespace){
    if (namespace){
      if (!this.namespaces[namespace]) {
        this.namespaces[namespace] = [fun];
      } else {
        this.namespaces[namespace].push(fun);
      }
    }
  },

  unbind(event, fun){
    if (typeof fun === "string"){
      if (this.namespaces[fun]){
        this.namespaces[fun].forEach((namespacedEvent) => {
          this.removeListener(event, namespacedEvent);
          this.listenerCounts--;
        });
        this.namespaces[fun] = [];
      } else {
        if (Fraction.debugger){ console.warn("Attempting to unbind a function that has never been bound."); }
      }
    } else {
      this.removeListener(event, fun);
      this.listenerCounts--;
    }
    this.setMaxListeners(this.getMaxListeners() - 1);
    // console.log("Unbinding Event", event);
    // console.log(`${this.listenerCounts}/${this.getMaxListeners()} Listeners`);
  }

});

export default Dispatcher;
